export const widgetConfig = {
    hotelId: '',
    ticker: '',
    engine: 'witbooking',
    showPrice: false,
    defaultAdults: 2,
    defaultChildren: 2,
    currency: 'EUR',
    baseUrl: '',
    urlChain: '',
    urlHotel: '',
    showChildAges: false,
    noOnDesktop: false,
    type: 'chain',
    maxRooms: '5',
    showAllHotelsOption: 'true',
};
